import http from '@/utils/http';

import type { IBaseResponse } from '@home/types/common';

// 获取腾讯云COS存储配置信息
export const fetchReportTencentQCouldMassage = (
  query?: { cos_config?: string },
  body?: any,
): IBaseResponse<ICOSAuthorizationData> => {
  return http({
    url: '/api/v1/intelligence_pc/report/auth',
    method: 'post',
    params: query,
    data: body,
    rawData: true,
  }) as Promise<any>;
};

export type ITencentQCouldMessageFetcher = () => Promise<ICOSAuthorizationData>;

export interface IFetchTencentQCouldMessage {
  fetchTencentQCouldMessage: ITencentQCouldMessageFetcher;
}

/**
 * 获取情报广州COS桶配置信息
 */
export const fetchDBIGZTencentQCouldMassage: ITencentQCouldMessageFetcher = async () => {
  const res = await fetchReportTencentQCouldMassage({ cos_config: 'guangzhou' });
  return res?.data;
};

/**
 * 获取情报新加坡COS桶配置信息
 */
export const fetchDBISingaporeTencentQCouldMassage: ITencentQCouldMessageFetcher = async () => {
  const res = await fetchReportTencentQCouldMassage({ cos_config: 'singapore' });
  return res?.data;
};
